import { render } from "./LedgerReport.vue?vue&type=template&id=1ebc2ff0&scoped=true"
import script from "./LedgerReport.vue?vue&type=script&lang=js"
export * from "./LedgerReport.vue?vue&type=script&lang=js"

import "./LedgerReport.vue?vue&type=style&index=0&id=1ebc2ff0&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebc2ff0"]])

export default __exports__